//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAppList } from '@/api/miniProgramManagement.js';
import { addconfig, updateconfig, getconfigbyid } from '@/api/configurationManagement.js';
import JSONEditor from 'jsoneditor';
const defaultExt = {
  ext: {},
  window: {},
  // extAppid: appid,
};
export default {
  components: {},
  data() {
    return {
      type: 'creat',
      id: null,
      loading: false,
      formData: {
        name: '',
        appid: [],
        app_name: [],
        ext_json: defaultExt,
        remarks: '',
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'change' }],
        appid: [{ required: true, message: '请选择所属小程序', trigger: 'change' }],
        ext_json: [
          { required: true, message: '请输入配置', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!this.hasJsonFlag) {
                callback(new Error('json格式错误'));
              } else {
                if (Object.keys(value).length === 0) {
                  callback(new Error('请输入配置'));
                } else {
                  callback();
                }
              }
            },
            trigger: 'change',
          },
        ],
      },
      hasJsonFlag: true, // json是否验证通过
      // 小程序列表
      appList: [],
      page_index: 1,
      page_size: 999,
      total: 0,
      appid: this.$route.query.appid || '',
    };
  },
  computed: {
    appIdList() {
      const obj = {};
      this.appList.forEach((item) => {
        obj[item.app_id] = item.app_name;
      });
      return obj;
    },
  },
  async created() {
    const { id, type } = this.$route.query;
    this.id = id || null;
    this.type = type || 'creat';
    if (id) {
      this.loading = true;
      this.getdetail();
    } else if (this.appid) {
      this.formData.appid = [this.appid];
    }
    this.getAppList();
  },
  mounted() {
    const dom = document.getElementById('jsoneditor');
    dom.innnerHTML = ''; // 防止重复触发
    this.editor = new JSONEditor(dom, {
      language: 'zh-CN',
      mode: 'code',
      showBtns: false,
    });
    this.editor.set(this.formData.ext_json);
  },
  methods: {
    async getdetail() {
      const res = await getconfigbyid({ id: this.id });
      let json = '';
      try {
        if (res?.config?.content) {
          json = JSON.parse(res.config.content);
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.$message.error('获取配置信息失败');
        this.loading = false;
      }
      this.editor.set(json || {});
      this.formData = {
        ...res.config,
        ext_json: json || {},
        appid: res?.config?.app_id.split(',') || [],
        app_name: res?.config?.app_name.split(',') || [],
      };
    },
    getAppList() {
      getAppList({
        app_id: this.appid,
        page_index: this.page_index,
        page_size: this.page_size,
        keywords: '',
        template_data: 2, // 全部
      })
        .then((res) => {
          const appList = res.list || [];
          this.appList = [...this.appList, ...appList];
          this.total = Number(res.total || 0);
        })
        .catch((err) => {
          this.$message.error(err.errmsg);
        });
    },
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        // ext_json内容检测
        const json = this.editor.get();
        if (
          Object.keys(json).some((key) => {
            return !['ext', 'window', 'extAppid'].includes(key);
          })
        ) {
          this.$confirm(
            `内容设置{"extAppid":'', "ext": {}, "window": {}}以外的参数,该配置只能用于普通模板`,
            '确认信息',
            {
              distinguishCancelAndClose: true,
              confirmButtonText: '确认',
              cancelButtonText: '修改内容',
              type: 'warning',
              center: true,
            },
          )
            .then(() => {
              this.update();
            })
            .catch((action) => {
              console.log(action);
            });
          return;
        }
        this.update();
      });
    },
    async update() {
      const req = {
        ...this.formData,
        content: JSON.stringify(this.editor.get()),
        app_id: this.formData.appid,
      };
      //   if (Object.keys(this.appIdList).includes(req.appid)) {
      req.app_name = this.formData.appid.map((appid) => {
        return this.appIdList[appid];
      });
      // .join(',');
      //   }
      delete req.ext_json;
      delete req.appid;
      console.log('数据---->', req);
      try {
        // 新建
        if (this.type === 'creat') {
          await addconfig(req);
        }
        // 编辑
        if (this.type === 'edit') {
          await updateconfig(req);
        }
        this.back();
      } catch (err) {
        console.log(err);
      }
    },
    back() {
      this.$router.go(-1);
    },
    // json处理
    onJsonChange(value) {
      // 实时保存
      this.onJsonSave(value);
    },
    onJsonSave(value) {
      this.formData.ext_json = value;
      this.hasJsonFlag = true;
    },
    onError(value) {
      console.log('json格式错误:', value);
      this.hasJsonFlag = false;
    },
  },
};
